<h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
    <span>View</span>
    <i class="fa fa-times model_close cursor-pointer" (click)="close()"></i>
</h1>

<div *ngIf="!previewLink" id="loader"></div>
<div class="card-view">
    <iframe *ngIf="previewLink" [src]="previewLink | safe " style="width:100%; height: 100%;" (load)="showMessage()"
        frameborder="0"></iframe>
</div>